class GwpElement extends HTMLElement {

    constructor() {
        super();
        this.attachShadow({mode: 'open'});
        this.cart = [];
        this.products = [];
        this.minimumPurchase = 0;
    }

    async connectedCallback() {
        const response = await fetch('/cart.json');
        const cart = await response.json();

        const noscript = this.querySelector('noscript');
        this.cart = cart;
        this.products = JSON.parse(noscript.textContent);
        // check if attribute enable is set and true
        this.minimumPurchase = this.getAttribute('minimumPurchase');
        this.registerWhenCartChanges();
        if (document.body.classList.contains('template-cart')) {
            this.validateGWP();
        }
    }

    validateGWP() {
        console.log("GWP Validation");
        if (this.getAttribute('enable') === 'true') {
            if (this.isAvailableToOffer() && !this.isOfferAlreadyInCart() && this.checkIfSomeProductHasQuantity()) {
                MicroModal.show('modal-1');
                window.customAddtoCartFunc.init();
            } else if (this.isOfferAlreadyInCart() && !this.isAvailableToOffer()) {
                this.removeOfferFromCart();
            }
        } else {
          removeOfferFromCart();
        }
    }

    consoleInfo() {
        console.log('test cart', this.cart);
        console.log('test products', this.products);
        console.log('test minimum purchase', this.minimumPurchase);
    }

    registerWhenCartChanges() {
        console.log('GWP Register Cart');
        document.addEventListener('product:added', async () => {
            console.log('GWP Add Product');
            const response = await fetch('/cart.json');
            const cart = await response.json();
            this.cart = cart;
            this.validateGWP();
        });
        document.addEventListener('cart:refresh', async () => {
            console.log('GWP Refresh Cart');
            const response = await fetch('/cart.json');
            const cart = await response.json();
            this.cart = cart;
            this.validateGWP();
        });
    }

    isAvailableToOffer() {
        return (
          this.cart.items.length > 0 && this.cart.items.reduce((acc, item) => acc + item.line_price / 100, 0) >= this.minimumPurchase
        );
    }

    isOfferAlreadyInCart() {
        return this.cart.items.some(item => item?.properties?._gwp_enabled);
    }

    async removeOfferFromCart() {
        const itemsToRemove = this.cart.items.filter(item => item?.properties?._gwp_enabled);
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                updates: itemsToRemove.reduce((acc, item) => {
                    acc[item.id] = 0;
                    return acc;
                }, {}),
            }),
        });
        window.location.reload();
    }

    checkIfSomeProductHasQuantity() {
        return this.products.some(product => product.available);
    }

    // render(cart) {
    //     const div = document.createElement('div');
    //     div.innerHTML = `
    //         <h1>Cart</h1>
    //         <ul>
    //             ${cart.map(item => `<li>${item.name}</li>`).join('')}
    //         </ul>
    //     `;
    //     this.shadowRoot.appendChild(div);
    // }
}

customElements.define('gwp-element', GwpElement);